function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26.029,
  r: 26,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.248 20.03v.75h1.75a2.25 2.25 0 0 1 2.25 2.25v8a2.25 2.25 0 0 1-2.25 2.25H18a2.25 2.25 0 0 1-2.25-2.25v-12A2.25 2.25 0 0 1 18 16.78h9.998a2.25 2.25 0 0 1 2.25 2.25v1Zm-1.012-2.238-.53.53.53-.53a1.75 1.75 0 0 0-1.238-.513H18a1.75 1.75 0 0 0 0 3.5h11.748v-1.75a1.75 1.75 0 0 0-.512-1.237Zm3.762 10.987h.75v-3.5h-1.75a1.75 1.75 0 0 0 0 3.5h1Zm0-4h.75v-1.75a1.75 1.75 0 0 0-1.75-1.75h-14a2.26 2.26 0 0 1-.75-.127l-.998-.352v10.23A1.75 1.75 0 0 0 18 32.78h13.998a1.75 1.75 0 0 0 1.75-1.75v-1.75h-1.75a2.25 2.25 0 1 1 0-4.5h1Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 1.5
});

function SvgWalletCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCircle);
export default __webpack_public_path__ + "static/media/wallet-circle.7f333c83523dd8a09449bcedd80d1c17.svg";
export { ForwardRef as ReactComponent };